import axios from 'axios';
import * as config from '../Config/api.js';

/**
 * Método para buscar imagens do endpoint /api/image
 * @param {string} query - termo de busca (ex: "praia", "neve")
 * @param {number} count - quantidade de imagens a buscar
 * @param {function} setImageArray - setter do useState para array de imagens
 */
export const fetchImagesFromAPI = async (query, count = 8, setImageArray, setImageCredits=null) => {
  try {
    const response = await axios.post(`${config.API_URL}/app/retrieveImages?query=${query}`, {
      params: { count }
    });

    if (response.data && response.data.success && Array.isArray(response.data.images)) {

      const regularImages = response.data.images
        .map(img => img.urls?.regular)
        .filter(Boolean);

        const credits = response.data.images
        .map(img => img.attribution?.photographer)
        .filter(Boolean);

      setImageArray(prev => [...prev, ...regularImages]);
      setImageCredits(prev => [...prev, ...credits]);

    } else {
      console.warn('[fetchImagesFromAPI] Resposta inesperada', response.data);
    }

  } catch (error) {
    console.error('[fetchImagesFromAPI] Erro ao buscar imagens:', error.message);
  }
};
